import AccountSettingsForm from './AccountSettingsForm';

export default AccountSettingsForm;
